// config/public/index.js
var env = process.env.NODE_ENV
if (env === 'test')
  env = 'development'
const config = require('./' + env)
module.exports = config


//////////////////
// WEBPACK FOOTER
// ./config/public/index.js
// module id = 25
// module chunks = 0